import * as React from 'react'

import { InputLabel } from '@material-ui/core'
import { display, spacing } from '@material-ui/system'
import { palette } from '@procurify/ui-theme'
import styled from 'styled-components'

import { type IInputLabelProps } from '../InputLabel'

export const InputLabelStyled = styled(
  ({ color, ...otherProps }: IInputLabelProps) => {
    return (
      <InputLabel
        {...otherProps}
        disableAnimation={true}
        shrink={true}
        classes={{
          asterisk: 'formLabelAsterisk',
          disabled: 'formLabelDisabled',
          error: 'formLabelError',
          focused: 'formLabelFocused',
          root: 'formLabelRoot',
        }}
      />
    )
  }
)`
  && {
    position: relative;
    display: inline-block;
    width: 100%;
    font-family: inherit;
    color: ${(props) => props.theme.colors.text.primary};
    font-weight: ${(props) => props.theme.fontWeights.bold};
    font-size: ${(props) =>
      props.theme.typography.pxToRem(props.theme.fontSizes.label)};
    transform: none;
    ${spacing}
    &.formLabelFocused {
      color: ${(props) => props.theme.colors.text.primary};
    }

    &.formLabelError {
      color: ${(props) => props.theme.colors.error};
    }

    &.formLabelDisabled {
      color: ${(props) => props.theme.colors.text.primary};
    }

    .formLabelAsterisk {
      color: ${(props) => props.theme.colors.red};
    }

    ${palette};
    ${display};
  }
`
InputLabelStyled.displayName = 'InputLabelStyled'
